import React from 'react';
import classNames from 'classnames';
import './FishBadge.css';
import { isFishPlayer } from '../../containers/StatPage/utils';

type Props = {
  vpip: number | null | undefined;
  className?: string;
};

const FishBadge = React.memo(({ vpip, className }: Props) => {
  if (!isFishPlayer(vpip)) {
    return null;
  }

  return (
    <span
      className={classNames('FishBadge', className)}
      title={`VPIP ${vpip}%`}
      aria-label={`VPIP ${vpip}% — fish`}
    >
      <span className="FishBadge__Icon" aria-hidden="true">
        🐟
      </span>
    </span>
  );
});

export default FishBadge;
